<template>
    <div class="">

        <section class="how-apply-area pt-100 pb-70">
            <div class="container">

                <div class="section-title">
                    <h2 v-if="!pgLoading">
                        {{ ($i18n.locale == 'en') ? items.en.title : items.ar.title }}
                    </h2>
                    <p v-if="!pgLoading"
                        v-html="($i18n.locale == 'en') ? items.en.body_striped : items.ar.body_striped">
                    </p>

                    <h2 v-if="pgLoading" class="webkit-animation col-4 offset-4 webkit-none-50"></h2>
                    <p v-if="pgLoading" class="webkit-animation col-6 offset-3 webkit-none-80"></p>
                </div>

                <div class="row" v-if="pgLoading">
                    <div v-for="(item, idx) in 6" :key="idx" class="col-sm-6 col-lg-4">
                        <div class="how-apply-item webkit-animation webkit-410-200"></div>
                    </div>
                </div>

                <div class="row" v-if="!pgLoading">
                    <div v-for="(item, idx) in items.childs" :key="idx" class="col-sm-6 col-lg-4">
                        <div class="how-apply-item">
                            <h3>
                                <a>{{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}</a>
                            </h3>
                            <p v-html="($i18n.locale == 'en') ? item.en.body : item.ar.body"></p>
                            <span class="sub-span mb-15">0{{ idx + 1 }}</span>
                        </div>
                    </div>
                </div>

            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'OurMission',
    components: {},
    data() {
        return {
            //
            items: [],
            pgLoading: true,
            refs: 'front-settings/our-values'
        }
    },
    mounted() { },
    created() {
        //
        this.fetchData();
    },
    methods: {
        //
        fetchData() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL + '/' + this.refs,
                method: 'GET',
                data: {},
                headers: {
                    appId: process.env.VUE_APP_APPID
                },
            }
            this.axios(options)
                .then(res => {
                    this.pgLoading = false;
                    this.items = res.data.data;
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
        },

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mb-15 {
    margin-bottom: -15px !important;
}
</style>
